const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const AUTHORIZATION_KEY = "Authorization";
const LOGIN_KEY = "logIn";
export const saveTokensToLocalStorage = (accessToken, refreshToken, logIn) => {
  const authorizationObject = {
    [LOGIN_KEY]: logIn,
    [ACCESS_TOKEN_KEY]: accessToken,
    [REFRESH_TOKEN_KEY]: refreshToken,
  };
  localStorage.setItem(AUTHORIZATION_KEY, JSON.stringify(authorizationObject));
};

export const getTokensFromLocalStorage = () => {
  const authorizationString = localStorage.getItem(AUTHORIZATION_KEY);
  if (authorizationString) {
    const authorizationObject = JSON.parse(authorizationString);
    const accessToken = authorizationObject[ACCESS_TOKEN_KEY];
    const refreshToken = authorizationObject[REFRESH_TOKEN_KEY];
    const logIn = authorizationObject[LOGIN_KEY];
    return { accessToken, refreshToken, logIn };
  }
  return { accessToken: null, refreshToken: null, login: false };
};

export const clearTokensFromLocalStorage = () => {
  localStorage.removeItem(AUTHORIZATION_KEY);
};
